import { RouterProvider } from 'react-router-dom';

// CSS
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './assets/styles/App.css';
import './assets/styles/darkmode.css';
import './assets/styles/unified-controls.css';
import './components/UnifiedForm.css';
import './assets/styles/axo-design-system.css'; // ← AXO Design System: unified buttons, spinners, skeletons

// routing
import router from './routes';

// project imports
import NavigationScroll from './layouts/NavigationScroll';
import ThemeCustomization from './themes';
import { SearchProvider } from './contexts/SearchContext';
import { ConfigProvider } from './contexts/ConfigContext';
import GlobalTextHighlighter from './utils/GlobalTextHighlighter';
import ErrorBoundary from './errorBoundary';
import ScrollableAppWrapper from './layouts/ScrollableAppWrapper';

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider>
        <ThemeCustomization>
          <ScrollableAppWrapper>
            <NavigationScroll>
              <SearchProvider>
                <>
                  <GlobalTextHighlighter />
                  <RouterProvider router={router} />
                </>
              </SearchProvider>
            </NavigationScroll>
          </ScrollableAppWrapper>
        </ThemeCustomization>
      </ConfigProvider>
    </ErrorBoundary>
  );
}
